var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVias2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vias_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.999,
    height: 69.999,
    viewBox: "0 0 69.999 69.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #c7d11d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M158.326,156a18.868,18.868,0,0,0-17.363,26.25H126.9v-7.109a1.367,1.367,0,1,0-2.734,0v8.476a1.367,1.367,0,0,0,1.367,1.367h16.87a18.949,18.949,0,0,0,1.266,1.762c.022.031.044.063.068.093l11.784,15.1h-6.409a1.367,1.367,0,1,0,0,2.734h18.464a1.367,1.367,0,0,0,0-2.734h-6.453l11.851-15.188.014-.019A18.861,18.861,0,0,0,158.326,156Zm12.511,29.051-.049.063-12.462,15.969-12.335-15.8a1.426,1.426,0,0,0-.109-.152,16.133,16.133,0,1,1,24.955-.083Z",
    transform: "translate(-107.194 -134.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M313.925,221.746a1.367,1.367,0,0,0-2.6.838,8.477,8.477,0,1,1-5.782-5.559,1.367,1.367,0,0,0,.729-2.636,11.211,11.211,0,1,0,7.656,7.355Z",
    transform: "translate(-252.122 -184.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-1",
    d: "M417.273,235.484l-.01-.014a1.367,1.367,0,1,0-1.933,1.933l.012.012a1.367,1.367,0,1,0,1.933-1.933Z",
    transform: "translate(-358.202 -202.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M32.037,420H1.367a1.367,1.367,0,0,0,0,2.734h29.3v8.476a1.367,1.367,0,1,0,2.734,0v-9.844A1.367,1.367,0,0,0,32.037,420Z",
    transform: "translate(0 -362.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M24.948,0a1.367,1.367,0,0,0-1.367,1.367v9.844H1.367a1.367,1.367,0,0,0,0,2.734H24.948a1.367,1.367,0,0,0,1.367-1.367V1.367A1.367,1.367,0,0,0,24.948,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M12.737,154H2.367a1.367,1.367,0,1,0,0,2.734h9v23.789h-9a1.367,1.367,0,1,0,0,2.734h10.37A1.367,1.367,0,0,0,14.1,181.89V155.367A1.367,1.367,0,0,0,12.737,154Z",
    transform: "translate(-0.863 -132.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M126.5,251.4a1.367,1.367,0,1,0,.4.967A1.367,1.367,0,0,0,126.5,251.4Z",
    transform: "translate(-107.193 -216.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M142.193,154H125.537a1.367,1.367,0,0,0-1.367,1.367v7.588a1.367,1.367,0,1,0,2.734,0v-6.221h15.289a1.367,1.367,0,1,0,0-2.734Z",
    transform: "translate(-107.194 -132.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M245.3,0a1.367,1.367,0,0,0-1.367,1.367v9.844h-20.4V1.367a1.367,1.367,0,0,0-2.734,0V12.578a1.367,1.367,0,0,0,1.367,1.367H245.3a1.367,1.367,0,0,0,1.367-1.367V1.367A1.367,1.367,0,0,0,245.3,0Z",
    transform: "translate(-190.613 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M446.75,11.211h-6.016V1.367a1.367,1.367,0,0,0-2.734,0V12.578a1.367,1.367,0,0,0,1.367,1.367h7.383a1.367,1.367,0,1,0,0-2.734Z",
    transform: "translate(-378.118 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M466.1,154h-4.318a1.367,1.367,0,0,0,0,2.734H466.1a1.367,1.367,0,0,0,0-2.734Z",
    transform: "translate(-397.473 -132.946)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVias2);
export default __webpack_public_path__ + "static/media/Vias2.bfd57052c2af68431ffc8f54b410c0f1.svg";
export { ForwardRef as ReactComponent };